import { BooleanInput, DateInput, NumberInput, ReferenceArrayInput, SelectArrayInput, TextInput } from 'react-admin'
import { InvoiceState } from '../GeneratedClients/FreeBillApi'

const InvoiceFilters = 
[
  <TextInput source="companyName_Contains" label={"resources.filter.companyNameContains"} alwaysOn resettable />,
  <TextInput source="invoiceNumber_Contains" label={"resources.filter.invoiceNumberContains"} alwaysOn resettable />,
  <NumberInput source="grossAmount_Gt" label={"resources.filter.grossAmountGt"} />,
  <NumberInput source="grossAmount_Lt" label={"resources.filter.grossAmountLt"} />,
  <DateInput source='invoiceDate_Gt' label={"resources.filter.invoiceDateGt"} />,
  <DateInput source='invoiceDate_Lt' label={"resources.filter.invoiceDateLt"} />,
  <DateInput source='dueDate_Gt' label={"resources.filter.dueDateGt"} />,
  <DateInput source='dueDate_Lt' label={"resources.filter.dueDateLt"} />,
  <SelectArrayInput source="invoiceState_Eq" label={"resources.filter.invoiceStateEq"} alwaysOn choices={[
    { id: InvoiceState.Pending, name: 'Offen'},
    { id: InvoiceState.Paid, name: 'Bezahlt'},
    { id: InvoiceState.PastDue, name: 'Fällig'},
    { id: InvoiceState.Failed, name: 'Abgebrochen'},
    { id: InvoiceState.Canceled, name: 'Storniert'}
  ]} />,
  <ReferenceArrayInput source='numberRangeId_Eq' reference='numberRanges' label={"resources.filter.numberRangeIdEq"} >
    <SelectArrayInput label={"resources.filter.numberRangeIdEq"} />
  </ReferenceArrayInput>,
  <BooleanInput source='isSendByMail' label={"resources.filter.isSendByMail"} />,
  <BooleanInput source='bookingInfos_EqNull' label={"resources.filter.bookingInfosEqNull"} />,
]

export default InvoiceFilters